// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'chart-line';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M.576.576v16.848h16.848m-5.472-8.136 3.384-4.176M7.272 8.424l2.952 1.368M.576 11.304l4.608-2.736' />
    <path d='M5.04 7.92c0 .648.504 1.152 1.152 1.152s1.152-.504 1.152-1.152-.504-1.152-1.152-1.152c-.648.072-1.152.576-1.152 1.152zm5.112 2.304c0 .648.504 1.152 1.152 1.152s1.152-.504 1.152-1.152c0-.648-.504-1.152-1.152-1.152s-1.152.504-1.152 1.152zm5.04-5.688c0 .648.504 1.152 1.152 1.152s1.152-.504 1.152-1.152-.504-1.152-1.152-1.152c-.648.072-1.152.576-1.152 1.152z' />
  </g>
);

export const viewBox = '0 0 18 18';
